import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import styles from './styles.module.scss'

type Props = {
  title: string
  path?: string
  onClick?: () => void | Promise<void>
  level?: '1' | '2' | '3' | '4' | '5' | '6'
  viewAll?: boolean
  viewAllText?: string
  img?: string
  used?: string
  className?: string
}

const TitleWithViewAll = ({
  title,
  path,
  onClick,
  level = '2',
  viewAll = true,
  viewAllText = 'すべて見る',
  img,
  used,
  className,
}: Props) => {
  const HeadingTag = `h${level}` as keyof React.JSX.IntrinsicElements

  const handleButtonClick = async () => {
    if (onClick) {
      await onClick()
    }
  }

  return (
    <HeadingTag
      className={clsx(
        styles.titleWithViewAll,
        { [styles.viewImg]: img },
        used && styles[used],
        className,
        'titleWithViewAll',
      )}
    >
      {img && (
        <div className={styles.bookImage}>
          <img
            src={img}
            alt={title}
            width={120}
            height={160}
            className={styles.titleImg}
            loading='lazy'
          />
        </div>
      )}
      {title}
      {viewAll && path && (
        <Link href={path} className={styles.viewAll}>
          {viewAllText}
        </Link>
      )}
      {viewAll && onClick && (
        <button type='button' onClick={handleButtonClick} className={styles.viewAll}>
          {viewAllText}
        </button>
      )}
    </HeadingTag>
  )
}

export default TitleWithViewAll
